// extracted by mini-css-extract-plugin
export default {"headerRightHalfContainer":"ProductCodes_headerRightHalfContainer__p7bwV","warningMessage":"ProductCodes_warningMessage__LkhM4"};